import * as $ from "jquery";
import * as ko from "knockout";
import * as _ from "lodash";

import {Command} from "../command";
import {CommandType} from "../commandType";
import {PopupType} from "../popups/popupType";
import {Application} from "../application";
import {CostbookCostPickerParams} from "../../components/costbook-cost-picker/costbook-cost-picker";
import {CostbookRow} from "../state/costbookRow";
import {EditorMode} from "../../components/estimate-cost-row-popup/estimate-cost-row-popup";

export class ChooseCostCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.ChooseCost;
    
    canExecute = ko.computed(() => {

        let costbook = this.app.state.costbook();

        if (!costbook)
            return false;

        return true;
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();


        let costbook = this.app.state.costbook();
        
        if(!costbook)
            return $.Deferred().reject().promise();
        
        let bufferItem = _.first(this.app.state.buffer());
        if(!bufferItem)
            return $.Deferred().reject().promise();
        
        let row = <CostbookRow>bufferItem.data;

        console.log("choosecost", row);
        
        let dfd = $.Deferred();
        
        
        let params : CostbookCostPickerParams = {
            pasteToTheEnd: bufferItem!.pasteToTheEnd,
            price: undefined,
            period: undefined
        };
        
        this.handle(row, params, dfd);
        
        return dfd.promise();
        
    }

    private handle(row: CostbookRow, params: CostbookCostPickerParams, deferred: JQueryDeferred<any>) {
        this.app.apiManager.costbook.getRow(row.attributes!.sectionId!,
            this.app.state.costbook()!.id, 
            this.app.state.estimate()!.postalCode(),
            this.app.state.estimate()!.equipmentAreaModApplied(),
            this.app.state.estimate()!.laborAreaModApplied(),
            this.app.state.estimate()!.materialAreaModApplied())
            .done((sectionRow) => {
                console.log("handling CCC");
                params.title = ChooseCostCommand.getSectionTitle(sectionRow);

                this.app.popupsManager.show<CostbookCostPickerParams>(PopupType.costPicker, false, params).fail(() => {
                    deferred.reject()
                }).done(() => {

                    console.log("chosen", params);

                    if (!params.price || !params.period) {
                        deferred.resolve();
                        return;
                    }

                    this.app.commandsManager.execute(CommandType.CreateEstimateCostRow, {
                        editorMode: EditorMode.Advanced,
                        insertAbove: false,
                        fromCostbook: true,
                        title: ChooseCostCommand.getSectionTitle(sectionRow),
                        price: params.price,
                        period: params.period,
                        insertToTheEnd: params.pasteToTheEnd,
                    })
                        .fail(() => {
                            //this.handle(row, params, deferred);//TNE-202.2
                        })
                        .done((data) => {
                            deferred.resolve(data)
                        });
                });
            });
    }

    public static getSectionTitle(row?: CostbookRow) : string {
        if (!row)
            return "";

        if (row.attributes.sectionTitle)
            return row.attributes.sectionTitle;

        if (row.attributes.sectionDescriptions) {
            return row.attributes.sectionDescriptions[0];
        }

        return "";
    }


    name = "Choose cost";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/chooseCostCommand.ts